import {useEffect, useId, useState} from "react";
import {useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CheckIcon, ThinPersonIcon} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

interface ticketMessage {
    id: number,
    adminId: number,
    message: string,
    createdAt: string,
}

export const AdminsTicketViewScreen = () => {
    const {ticketNd} = useParams();
    const [messages, setMessages] = useState<ticketMessage[]>([]);
    const [data, setData] = useState({
        loaded: false,
        title: '',
        studentId: 0,
        name: '',
        createdAt: '2000-01-01 00:00:00',
        isClosed: false,
        closedAt: '2000-01-01 00:00:00',
        category:1,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/tickets/get',
            {
                nd: ticketNd,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                title: string,
                studentId: number,
                name: string,
                createdAt: string,
                isClosed: 0 | 1,
                closedAt: string,
                messages: ticketMessage[] | null,
                category:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    closedAt: d.closedAt,
                    isClosed: d.isClosed === 1,
                    name: d.name,
                    createdAt: d.createdAt,
                    studentId: d.studentId,
                    title: d.title,
                    category: d.category,
                });
                setMessages(d.messages === null ? [] : d.messages);
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مشاهده تیکت | نهال";
        fetchData();
    }, []);
    const closeTicket = (isClosed: boolean) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/tickets/close',
            {
                nd: ticketNd,
                isClosed: isClosed ? '0' : '1',
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData(v => {
                    let x = {...v};
                    x.isClosed = !x.isClosed;
                    return x;
                });
                ShowSnackbar(
                    'وضعیت تیکت تغییر یافت.',
                    'باشه',
                    5000,
                );
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const newMessageId = useId();
    const [newMessage, setNewMessage] = useState('');
    const [newMessageErr, setNewMessageErr] = useState(false);
    const [sendSms,setSendSms] = useState(true);
    const sendMessage = () => {
        const sms = sendSms;
        const m = newMessage.trim();
        if(m.length < 3){
            setNewMessageErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/tickets/send',
            {
                nd:ticketNd,
                message:m,
                sms:sms ? '1' : '0',
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowProgressLoading();
                fetchData();
                ShowSnackbar(
                    'پیام جدید ارسال گردید',
                    'باشه',
                    5000,
                );
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins'},
                {title: 'تیکت', url: '/admins/tickets'},
                {title: 'مشاهده تیکت', url: `/admins/tickets/view/${ticketNd}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>مشاهده تیکت</b>
                                <button onClick={() => closeTicket(data.isClosed)}>
                                    <CheckIcon/>
                                    <span>{data.isClosed ? 'بازکردن تیکت' : 'بستن تیکت'}</span>
                                </button>
                            </div>
                            <b style={{display:'block',}}>عنوان تیکت: {data.title}</b>
                            <span style={{display:'block',fontSize:14,marginTop:5}}>نوع تیکت: {data.category === 2 ? 'پرسش پشتیبانی' : 'پیشنهادات و انتقادات'}</span>
                            <hr/>
                            {
                                messages.map((m, i) =>
                                    <div
                                        key={"K39fm3jsAA2A"+i}
                                        className={"row justify-content-" + (m.adminId > 0 ? 'end' : 'start')}>
                                        <div className="col-md-6">
                                            <div className="ticket-message">
                                                <div>
                                                    <i><ThinPersonIcon/></i>
                                                    <b>{m.adminId > 0 ? 'مدیریت سایت' : data.name}</b>
                                                </div>
                                                <p>{m.message}</p>
                                                <span>{StringDigitsConvertToPersian(m.createdAt.split(' ')[1]) + " " + StringDigitsConvertToPersian(GregorianToPersian(m.createdAt.split(' ')[0])).replaceAll('-', '/') }</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            <hr/>
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <label htmlFor={newMessageId}>پیام جدید:</label>
                                    <textarea
                                        id={newMessageId}
                                        className={"form-control" + (newMessageErr ? ' is-invalid' : '')}
                                        value={newMessage}
                                        style={{minHeight: 200, maxHeight: 500}}
                                        onChange={e => {
                                            let t = e.currentTarget.value;
                                            setNewMessage(t);
                                            setNewMessageErr(false);
                                        }}/>
                                    <div className={"invalid-feedback" + (newMessageErr ? ' d-block' : ' d-none')}>
                                        لطفا حداقل ۳ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{marginTop: 20}}/>
                                    <button className={"techaran-checkbox" + (sendSms ? ' active' : '')}
                                            onClick={() => setSendSms(v => !v)}>
                                        <i><CheckIcon/></i>
                                        <span>
                                    ارسال پیامک
                                    <em>ارسال پیامک اطلاع‌رسانی پاسخ جدید به والدین.</em>
                                </span>
                                    </button>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{marginTop: 20}}>
                                        <button className="btn-pay" onClick={sendMessage}>
                                            <b>ارسال پیام</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};